import React, { useState } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import { DialogTitle, Fab } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import DeleteGroupDialog from './DeleteSubjectGroupDialog'
import { useIsLargeView, useIsMobileView } from '../hooks/useIsMobileView'
import NewOrEditGroupDialog from './NewOrEditSubjectGroupDialog'
import { Role } from '../types/user'

const SubjectGroups = (): JSX.Element => {
  const { subjectGroups, subjects, role } = useSelector(
    (state: State) => state.user
  )
  const [selectedRowIds, setSelectedRowIds] = useState<number[]>([])
  const [selectedRowIdsToDelete, setSelectedRowIdsToDelete] = useState<
  number[]
  >([])
  const [group, setGroup] = useState<any | null>(null)
  const [isNewOrEditGroupDialogOpen, setIsNewOrEditGroupDialogOpen] =
    useState(false)
  const [isDeleteGroupDialogOpen, setIsDeleteGroupDialogOpen] = useState(false)
  const isMobileView = useIsMobileView()
  const isLargeView = useIsLargeView()

  const SubjectsList: React.FC<{ id: number }> = ({ id }) => {
    const group = subjectGroups.find(g => g.id === id)!
    const subjectNames = group.subjectGroupProposal.map(
      s => `${subjects.find(sub => sub.id === s.subjectId)?.name}`
    )

    return <div>{subjectNames.join(', ')}</div>
  }

  const isAuthorized = role === Role.SUPERADMIN || role === Role.ADMIN

  const OptionsButton: React.FC<{ id: number }> = ({ id }) => {
    return isAuthorized
      ? (
        <div>
          <Fab
            size='small'
            onClick={() => {
              setGroup(subjectGroups.find(g => g.id === id) as any)
              setIsNewOrEditGroupDialogOpen(true)
            }}
            color='warning'
            aria-label='edit'
            style={{ transform: 'scale(0.8)' }}
          >
            <EditIcon />
          </Fab>
          <Fab
            size='small'
            onClick={() => {
              setSelectedRowIdsToDelete([id])
              setIsDeleteGroupDialogOpen(true)
            }}
            color='error'
            aria-label='delete'
            style={{ transform: 'scale(0.8)' }}
          >
            <DeleteIcon />
          </Fab>
        </div>
        )
      : (
        <></>
        )
  }

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', width: 250 },
    {
      field: 'subjects',
      headerName: 'Subjects Combination',
      width: 400,
      renderCell: params => <SubjectsList id={params.row.id} />
    },
    {
      field: 'options',
      headerName: '',
      width: 100,
      renderCell: params => <OptionsButton id={params.row.id} />
    }
  ]

  return (
    <div
      style={{
        height: isMobileView ? '75vh' : '60vh',
        width: isMobileView ? '80vw' : isLargeView ? '50vw' : '70vw',
        margin: 'auto',
        marginBottom: '5vw'
      }}
    >
      {/* <DialogTitle>Subject Groups</DialogTitle> */}
      {isAuthorized && (
        <>
          <Fab
            size='small'
            color='primary'
            aria-label='add'
            onClick={() => {
              setGroup(null)
              setIsNewOrEditGroupDialogOpen(true)
            }}
            style={{ margin: '1vw' }}
          >
            <AddIcon />
          </Fab>
          <Fab
            size='small'
            onClick={() => {
              setSelectedRowIdsToDelete(selectedRowIds)
              setIsDeleteGroupDialogOpen(true)
            }}
            color='error'
            aria-label='delete'
            disabled={selectedRowIds.length === 0}
          >
            <DeleteIcon />
          </Fab>
        </>
      )}
      <DataGrid
        disableRowSelectionOnClick
        rows={subjectGroups}
        columns={columns}
        checkboxSelection={isAuthorized}
        onRowSelectionModelChange={newSelection => {
          setSelectedRowIds(newSelection as number[])
        }}
      />
      {isNewOrEditGroupDialogOpen && (
        <NewOrEditGroupDialog
          handleClose={() => setIsNewOrEditGroupDialogOpen(false)}
          group={group}
        />
      )}
      {isDeleteGroupDialogOpen && (
        <DeleteGroupDialog
          handleClose={() => setIsDeleteGroupDialogOpen(false)}
          ids={selectedRowIdsToDelete}
        />
      )}
    </div>
  )
}

export default SubjectGroups
